// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._GjmiUoVN6GWuT0QcTxx {\n    border-color: #055D9C !important;\n    color: #055D9C !important;\n    margin-right: 10px !important;\n    \n}", "",{"version":3,"sources":["webpack://./src/areas/client/map/styles/MapDashboard.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,6BAA6B;;AAEjC","sourcesContent":[".viewSystemChip {\n    border-color: #055D9C !important;\n    color: #055D9C !important;\n    margin-right: 10px !important;\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"viewSystemChip": "_GjmiUoVN6GWuT0QcTxx"
};
export default ___CSS_LOADER_EXPORT___;
